export default {
  heading: "Change Password",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  passwordStrength: "Password Strength: ",
  lengthInfo: "New password must contain at least {minlength} characters",
  complexText: {
    1: "which can be uppercase letters, lowercase letters, numbers or special characters",
    2: "with at least two of the following: uppercase letters, lowercase letters, numbers or special characters",
    3: "with at least three of the following: uppercase letters, lowercase letters, numbers or special characters",
    4: "with all of the following: uppercase letters, lowercase letters, numbers and special characters"
  },
  strength: {
    0: "Very Weak",
    1: "Weak",
    2: "Medium",
    3: "Strong",
    4: "Very Strong"
  },
  currentPasswordIsEmpty: "Please enter your current password.",
  currentPasswordIsWrong: "The current password you entered is incorrect.",
  newPasswordIsEmpty: "Please enter your new password.",
  newPasswordIsNotSecurity: "The new password you entered does not meet the security requirements. Please try again.",
  newPasswordIsSameAsOld: "The new password you entered is the same as the old password. Please enter a different password.",
  confirmNewPasswordIsEmpty: "Please re-enter your new password.",
  confirmNewPasswordIsNotSame: "The password you entered does not match. Please try again.",
  confirmDialogContent: "Confirm password change?",
  confirmUpdate: "Ok",
  cancelUpdate: "Cancel",
  closeBtn: "Close",

};
